import { createReducer, on } from '@ngrx/store';
import { KeyboardActions } from './keyboard.actions';
import { initialKeyboardState } from './keyboard.state';

export const keyboardReducer = createReducer(
  initialKeyboardState,

  on(KeyboardActions.willShow, (state, { height }) => ({
    ...state,
    height: height,
    isOpening: true
  })),
  on(KeyboardActions.didShow, (state) => ({
    ...state,
    isOpen: true,
    isOpening: false
  })),
  on(KeyboardActions.didHide, (state) => ({
    ...state,
    height: 0,
    isOpen: false,
    isOpening: false
  }))
);
